import React, {useContext} from 'react'
import {I18nContext} from "utils/i18n/locale";
import {LAYOUT} from "components/molecules/Graphs";
import LinePlot from "components/molecules/Graphs/Line";

const CreatedFlags = () => {
	const {translate} = useContext(I18nContext);

	// This should be replaced with an API Call
	const DATA = [
		{
			"x": '2018-01-11',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-12',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-13',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-14',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-15',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-16',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-17',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-18',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-19',
			"y": 0,
			"category": "Pending",
		},
		{
			"x": '2018-01-20',
			"y": 0,
			"category": "Pending",
		}
	]

	return (
		<LinePlot
			height='100%'
			layout={LAYOUT.HORIZONTAL}
			showLegend={false}
			title={translate("pages").analytic.editor.sidePane.menu.createdFlags}
			data={DATA}
			indexBy="category"
			maxXScale={10}
			maxYScale={1000}
			animate={true}
			enableSlices='x'
			xScale={{
				type: 'time',
				format: '%Y-%m-%d',
				useUTC: false,
				precision: 'day',
			}}
			yScale={{
				max: 1.0,
				min: -1.0
			}}
			varyingSize={false}
			keyPoints={{
				"Pending": "#000000",
			}}/>
	)
}

export default CreatedFlags;
